module.exports = new __parcel__URL__("apply_c_faq_expanded_ko.d48be406.webp").toString();